import { render } from "./ApplicationSettings.vue?vue&type=template&id=6b288804"
import script from "./ApplicationSettings.vue?vue&type=script&lang=js"
export * from "./ApplicationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__